const data = {
  text_template: JSON.stringify({
      "blocks": [
        {
          "key": "6qn3",
          "text": "HISTORY OF PRESENTING ILLNESS",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 29,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 29,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text3",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "vasculoqoltitle",
          "text": "VASCULAR QUALITY OF LIFE QUESTIONNAIRE (VASCUQOL-6)",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 51,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 51,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textemptyVasculoqol1",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textVasculoqol1",
          "text": "The VascuQoL-6 aims to assess QoL in PAD regardless of disease severity (i.e., in intermittent claudication and in critical limb ischemia).  The main goal of vascular surgical treatment efforts in peripheral arterial disease (PAD) is limb salvage in critical limb ischemia and improvement of walking ability in intermittent claudication. The treatment effort outcomes require to address the PAD patient’s own perception about his or her actual functional walking capacity, pain discomfort, or the social and emotional implications of living with PAD is an essential measures to provide clinically useful additional decision-basis and also important information about the results of different medical interventions.",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textemptyVasculoqol2",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textemptyVasculoqol3",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "pactp3",
          "text": "PATIENT ACTIVE PROBLEM LIST",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 27,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 27,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text21",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "0i92j",
          "text": "PAST MEDICAL HISTORY",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 20,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 20,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text11",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "3d92j",
          "text": "PAST SURGICAL HISTORY",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 21,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 21,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text12",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "xao2j",
          "text": "MEDICATIONS",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 11,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 11,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text13",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "xmlsj",
          "text": "ALLERGIES",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 9,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 9,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text14",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "smxksj",
          "text": "FAMILY HISTORY",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 14,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 14,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text15",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "fmlis",
          "text": "SOCIAL HISTORY",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 14,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 14,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text16",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "tviwe2",
          "text": "REVIEW OF SYSTEMS",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 17,
              "style": "UNDERLINE"
            },
            {
              "offset": 0,
              "length": 17,
              "style": "BOLD"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text4",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "e3e6l",
          "text": "OBJECTIVE",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 9,
              "style": "UNDERLINE"
            },
            {
              "offset": 0,
              "length": 9,
              "style": "BOLD"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text5",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "physicheader",
          "text": "PHYSICAL EXAMINATION",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 20,
              "style": "UNDERLINE"
            },
            {
              "offset": 0,
              "length": 20,
              "style": "BOLD"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text6",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "darev",
          "text": "DATA REVIEWED",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 14,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 14,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text17",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "7qqlb",
          "text": "ASSESSMENT",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 10,
              "style": "UNDERLINE"
            },
            {
              "offset": 0,
              "length": 10,
              "style": "BOLD"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text8",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "fjqg5",
          "text": "PLAN",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 4,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 4,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text9",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textemptyamos4",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "amosduj2",
          "text": "AMPLIFIERS OF CARDIOVASCULAR AND LIMB-RELATED RISK IN PATIENTS WITH PERIPHERAL ARTERY DISEASE",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 93,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 93,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textemptyamos1",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textasmosduj1",
          "text": "Clinicians are required to actively pursue evidence of health disparities in diagnosis, treatment, and outcomes for patients with PAD and use efforts to limit the impact of these disparities on clinical outcomes. (COR I)",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textemptyamos2",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textasmosduj2",
          "text": "Non-White patients in the United States have high rates of risk-amplifying comorbidities of PAD and higher risk of adverse outcomes. In the United States, Non-White patients have a higher risk of limb amputation compared with White populations.  In addition, disparities in medical insurance and access to experienced health care centers providing advanced care for PAD and limb salvage procedures may contribute to the increased potential for lower extremity amputation. The disproportionately higher risk of amputation among patients of underrepresented racial and ethnic groups may also reflect systemic bias as studies have shown that Non-White patients with PAD are more likely to undergo amputation without attempts at revascularization and are more frequently treated with proximal amputation than White patients.",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textemptyamos3",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "discu1s",
          "text": "DISCUSSION",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 10,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 10,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text10",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "texttabelshow",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "cofesda",
          "text": "CLASSIFICATION OF EVALUATION:",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 28,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 28,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "cofeempty",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "icdhead",
          "text": "ICD-10 CODES WITH THE ENCOUNTER",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 31,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 31,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "icdempty",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "cpthead",
          "text": "CPT CODES WITH THE ENCOUNTER",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 28,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 28,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "cptempty",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "cpticdhead",
          "text": "CPT CODES WITH ASSOCIATED ICD-10 CODES AND MODIFIERS",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 52,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 52,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "cpticdempty",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "mipssd",
          "text": "MIPS COMPLIANCE - MIPS ASSESSMENTS",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 35,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 35,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "mipssdempty",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text25",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "pklcs",
          "text": "PROVIDER",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 8,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 8,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text18startspace",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text18",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 0,
              "style": ""
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "sikcma",
          "text": "SIGNATURE",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 9,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 9,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textsigsmall",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "textsigsmallempty",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "dimaks",
          "text": "DATE FINALIZED",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [
            {
              "offset": 0,
              "length": 14,
              "style": "BOLD"
            },
            {
              "offset": 0,
              "length": 14,
              "style": "UNDERLINE"
            }
          ],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text20startspace",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        },
        {
          "key": "text20",
          "text": "",
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }
      ],
      "entityMap": {}
    })};

export default data;
